<template>
	<v-app> 
		<div v-if="$store.state.language">
			<Navbar />
			<v-main  class="mb-10">
				<router-view />
			</v-main>
			<Footer />
		</div>
		<div v-else class="d-flex justify-center align-center" style="height: 100vh">
			<v-progress-circular 
				indeterminate
				color="primary"
			></v-progress-circular>
		</div>
	</v-app>
</template>

<script>

import Vue from 'vue'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
	name: 'App',
	components: {Navbar, Footer},
	data: () => ({

	}),
	watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = 'Nao ' + this.$t(to.meta.title) || '';
            }
        },
    }
};

</script>

<style>

#app {
	color: #3d414a;
}

.main_color {
	color: #0E4488;
}

.b_naoword b {
	color: #0E4488;
	font-weight: 500;
	white-space: pre;
}

.english_word {
	background-color: #d26e0460;
}

.i_english i {
	background-color: #d26e0460;
	font-style: normal;
	padding-left: 3px;
	padding-right: 3px;
	white-space: pre;
}

.v-icon {
	background-color: #00000000 !important;
}

.NOWRAP {
	white-space: pre;
}

.WRAP {
	white-space: normal;
}

.speaker_button {
	height: 0px !important;
}

</style>